import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiFillInstagram,
  AiOutlineWhatsApp,
  AiFillFacebook,
} from "react-icons/ai";
import { FaTelegramPlane } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              SEDIKIT <span className="purple"> PERKENALAN </span> DARI SAYA
            </h1>
            <p className="home-about-body">
              Saya salah seorang pemuda yang gemar mengisi hari-hari dengan duduk
              di depan komputer ... 👨🏼‍💻
              <br />
              <br />Beberapa bahasa pemograman yang saya kuasai
              <i>
                <b className="purple"> Java, Javascript and Python. </b>
              </i>
              <br />
              <br />
              Selain di bidang pemograman,&nbsp;
              <i>
                <b className="purple">Graphic Design </b> juga saya pelajari 
                sedari masih di bangku sekolah dengan{" "}
                <b className="purple">
                  software CorelDraw, Canva, dan Photoshop.
                </b>
              </i>
              <br />
              <br />
              Sekarang ini, Saya lebih banyak menghabiskan waktu untuk 
              <b className="purple"> belajar</b> dan
              <i>
                <b className="purple">
                  {" "}
                  membuat artikel tentang berbagai pengetahuan teknologi
                </b>
              </i>
              &nbsp; untuk mengisi blog saya.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>Lebih Lengkapnya</h1>
            <p>
              Anda dapat <span className="purple">terhubung </span>dengan saya
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://t.me/hatdnt"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaTelegramPlane />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.facebook.com/profile.php?id=100011677842364&mibextid=ZbWKwL"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillFacebook />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://wa.me/6285161920407"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineWhatsApp />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/hatdnt_/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
